<div  class="document-downloader" [ngClass]="{'document-downloader-class': !isOpenInDocumentEditor}">
  <button type="button" mat-button [disabled]="disabled" (click)="download()">
    <mat-icon aria-hidden="false" aria-label="Download">file_download</mat-icon>
    <span *ngIf="isOpenInDocumentEditor">Download</span>
    <span *ngIf="!isOpenInDocumentEditor">{{componentDefinition?.label}}</span>
    <a class="ng-hide" [hidden]="true" [id]="'downloadJSON'+componentDefinition?.name"
       [download]="'template_'+currentOpenedDocument.documentId +'.json'"></a>
  </button>
</div>
